import React from 'react'
import { GeoAltFill } from 'react-bootstrap-icons'

export const AddressOption = ({ address, showAddressDetail }) => {
  const [show, setShow] = React.useState(false)
  const addressStreet =
    address?.AddressInfo?.Street || address?.AddressInfo?.AddressDetail
  const handleEditAddress = () => {
    showAddressDetail({
      ...address?.AddressInfo,
      DefaultShippingAddress: address?.DefaultShippingAddress,
      DefaultBillingAddress: address?.DefaultBillingAddress,
    })
  }

  return (
    <div
      style={{ position: 'relative' }}
      data-testid="container-address-option">
      {!!addressStreet && (
        <div
          className="tooltip"
          style={show ? { visibility: 'visible' } : {}}
          onMouseEnter={() => setShow(true)}
          onMouseLeave={() => setShow(false)}
          data-testid="container-address-tooltip">
          {addressStreet}
          <button
            onClick={handleEditAddress}
            className="address-edit-button"
            data-testid="btn-edit-address">
            Editar
          </button>
        </div>
      )}
      <div
        className="customer-info-sidebar-address"
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        data-testid="container-address-info">
        <div>
          <GeoAltFill style={{ color: 'red' }} />
        </div>
        <p>{address.AddressInfo.Name || addressStreet}</p>
      </div>
    </div>
  )
}
